module.exports = __webpack_public_path__ + "static/media/elo.df3de5f7.png";